import React from "react";

import { ProductTileModel } from "@api/mappers/products.mapper";

import { ProductTileLayout } from "@components/Product/ProductTile/productTile.config";
import { ProductTile } from "@components/Product/ProductTile/productTile.container";

type BundleProductComponentProps = {
    bundleProduct: ProductTileModel;
};

const BundleProductComponent = ({
    bundleProduct,
}: BundleProductComponentProps) => (
    <>
        <div
            className={
                "productBundle__separator px-3 d-flex flex-column justify-content-center flex-grow-0"
            }
        >
            <i className={"las la-plus"}></i>
        </div>
        <ProductTile
            className={"flex-grow-1 w-100"}
            sku={bundleProduct.sku}
            product={bundleProduct}
            allowInstantAddToCart={false}
            productTileConfig={{
                amountOfFeatures: 0,
                components: ProductTileLayout.BUNDLE(),
            }}
        />
    </>
);

export { BundleProductComponent };
